import { Link, Outlet } from 'react-router-dom';
import { MainNav } from '@/components/navigation/MainNav';
import { UserMenu } from '@/components/UserMenu';
import { CommunicationBadge } from '@/components/communication/CommunicationBadge';
import { AdminBadge } from '@/components/admin/AdminBadge';
import { FeedbackButton } from '@/components/feedback/FeedbackButton';
import { SiteFooter } from '@/components/layout/SiteFooter';
import logo from '@/assets/logo.png';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-background">
      {/* Persistent Header */}
      <header className="border-b border-border/50 bg-card/50 backdrop-blur-sm sticky top-0 z-10 h-16">
        <div className="container h-full flex items-center justify-between">
          <div className="flex items-center gap-6 h-full">
            <Link to="/" className="h-full py-2">
              <img src={logo} alt="Vaultsy" className="h-full w-auto object-contain" />
            </Link>
            <nav aria-label="Main navigation">
              <MainNav />
            </nav>
          </div>
          <div className="flex items-center gap-2">
            <AdminBadge />
            <CommunicationBadge />
            <UserMenu />
          </div>
        </div>
      </header>

      {/* Page Content - only this refreshes on navigation */}
      <Outlet />

      <SiteFooter />

      {/* Floating Feedback Button */}
      <FeedbackButton />
    </div>
  );
}
